export default __webpack_public_path__ + "static/media/brick.7c0519fd.svg";